// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"532":"styles","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] || chunkId) + "-" + {"532":"cced948f5f83005da361","589":"b0abd9e20b48ec0aeeae","678":"9954adc3a404ebd4eed9","883":"5b30d57f8bad59bd0be1"}[chunkId] + ".js";
};